import React, { lazy } from 'react';
import { RouteProps } from 'react-router-dom';
import { dashboardPagesMenu, demoPagesMenu } from '../menu';

const LANDING = {
	DASHBOARD: lazy(() => import('../pages/presentation/dashboard/DashboardPage')),
	BO_APPROVAL: lazy(() => import('../pages/presentation/bo/BoApprovalPage')),
	WIZARD: lazy(() => import('../pages/presentation/bo/Wizard')),
	BOGREETINGS: lazy(() => import('../pages/presentation/bo/BOGreetings')),
	INDIVIDUAL_NOTE: lazy(() => import('../pages/presentation/bo/IndividualNote')),
	JOINT_NOTE: lazy(() => import('../pages/presentation/bo/JointBONote')),
};

const AUTH = {
	PAGE_404: lazy(() => import('../pages/presentation/auth/Page404')),
	LOGIN: lazy(() => import('../pages/presentation/auth/Login')),
};

const presentation: RouteProps[] = [
	/**
	 * Landing
	 */
	{
		path: dashboardPagesMenu.dashboard.path,
		element: <LANDING.DASHBOARD />,
	},
	{
		path: dashboardPagesMenu.boApproval.path,
		element: <LANDING.BO_APPROVAL />,
	},
	{
		path: dashboardPagesMenu.wizard.path,
		element: <LANDING.WIZARD />,
	},
	{
		path: dashboardPagesMenu.bogreetings.path,
		element: <LANDING.BOGREETINGS />,
	},
	{
		path: dashboardPagesMenu.individualNote.path,
		element: <LANDING.INDIVIDUAL_NOTE />,
	},
	{
		path: dashboardPagesMenu.jointNote.path,
		element: <LANDING.JOINT_NOTE />,
	},
	/** ************************************************** */
	/**
	 * Pages
	 */
	/**
	 * Single Pages
	 */
	/**
	 * List
	 */
	/**
	 * Edit
	 */
	/**
	 * Auth Page
	 */
	{
		path: demoPagesMenu.login.path,
		element: <AUTH.LOGIN />,
	},
	{
		path: demoPagesMenu.page404.path,
		element: <AUTH.PAGE_404 />,
	},
	/**
	 * END - App
	 */

	/** ************************************************** */

	/**
	 * Page Layout Types
	 */
];

const contents = [...presentation];

export default contents;
